// extracted by mini-css-extract-plugin
export var emailBlockLink = "_j8-0";